import requestHelper from './requestHelper';

const errorsUrl = "/iapi/ErrorCode?lang=";

class ErrorsList {
    constructor() {
    }

    init(){
      // console.log('get errors from api');

      this.errorList;
      this.lang = document.documentElement.getAttribute('lang');

      if (this.lang+"" == 'null' ) this.lang = "pl-PL";

      let lStorage = localStorage.getItem('errorsList') ? JSON.parse(localStorage.getItem('errorsList')) : {};
      
      if(lStorage && lStorage.lang == this.lang){
        this.errorList = lStorage.list;
      }else{
        requestHelper
        .request("get", errorsUrl + this.lang )
        .then(res => {

          this.errorList = JSON.parse(res);

          lStorage.lang = this.lang;
          lStorage.list = this.errorList;

          localStorage.setItem('errorsList', JSON.stringify(lStorage));

        })
        .catch(e => console.log(e));
      }

    }

    getError(errorCode){

      if (!this.errorList){
        return ''
      }

      if (this.errorList.length == 0) return '';

      let error = this.errorList.find(obj => {
        return obj.Code === String(errorCode);
      });

      if (error) return error.Key;

      error = this.errorList.find(obj => {
        return obj.Code === "0";
      })

      return error.Key

    }

    showError(errorCode, field){
      let errorText = this.getError(errorCode);
      if (errorText != '') field.innerHTML = errorText;
    }


}

const errors = new ErrorsList();

export default errors;